module.exports = __webpack_public_path__ + "img/frame (239).4c09356e.jpg";